<template>
  <PopupModal :open="open" @close="close">
    <template #header>
      <p class="textHeadline3">
        {{ $t("more.delete.userProfile.title") }}
      </p>
    </template>
    <template #body>
      <form ref="form">
        <p
          class="textBody1"
          v-html="$t('more.delete.userProfile.description')"
        ></p>
        <input
          v-model="password"
          class="input-primary mt-3"
          :placeholder="$t('more.delete.userProfile.placeholder')"
          type="password"
          required
        />
        <p v-if="showPasswordError" class="text-red-600 mt-2">
          {{ $t("more.delete.userProfile.passwordIncorrect") }}
        </p>
        <p v-if="showSuccessText" class="text-green-600 mt-2">
          {{ $t("more.delete.userProfile.success") }}
        </p>
      </form>
    </template>
    <template #footer>
      <button class="button-primary mx-auto block" @click="deleteProfile">
        {{ $t("more.delete.userProfile.delete.button") }}
      </button>
    </template>
  </PopupModal>
</template>

<script>
import PopupModal from "../layout/PopupModal.vue";
import { deleteProfile } from "~/api/user";

export default {
  name: "DeleteSbkProfileModal",
  components: { PopupModal },
  props: {
    open: Boolean,
  },
  data() {
    return {
      password: null,
      showPasswordError: false,
      showSuccessText: false,
    };
  },
  methods: {
    deleteProfile() {
      this.showPasswordError = false;
      this.showSuccessText = false;

      if (this.$refs.form.reportValidity()) {
        deleteProfile(this.password)
          .then(async () => {
            await this.logoutUser();
          })
          .catch(async (error) => {
            if (error.response.status === 400) {
              this.showPasswordError = true;
            } else {
              // we always pretend its successful, errors are handled by support
              await this.logoutUser();
            }
          });
      }
    },
    async logoutUser() {
      this.showSuccessText = true;
      await new Promise((res) => setTimeout(res, 2000));
      this.$userAuthenticator.logout();
      this.$router.push({
        name: "login",
      });
    },
  },
};
</script>
